import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { EstablishmentService } from '../../../../services/establishment.service';

@Component({
  selector: 'app-second-step-candidat',
  templateUrl: './second-step-candidat.component.html',
  styleUrl: './second-step-candidat.component.scss',
})
export class SecondStepCandidatComponent {
  @Input() form: FormGroup;
  @Output() onSubmit = new EventEmitter<any>();
  addressList: any[] = [];
  constructor(private establishmentService: EstablishmentService) {}
  ngOnInit(): void {
   
  }
  autoCompleteOnChange(event: any) {
    this.getAddresses(event?.value);
  }
  getAdresseFormated(option: any) {
    const address = option?.address || {};
    const house_number = address?.house_number || '';
    const road = address?.road || ''; 
    const postcode = address?.postcode || ''; 
    const city = address?.city || ''; 
    const country = address?.country || ''; 
    const addressComponents = [
        house_number,
        road,
        `${postcode} ${city}`,
        country
    ];
    const filteredComponents = addressComponents.filter(component => component.trim() !== '');
    return filteredComponents.join(', ')
}
  getAddresses(wordKey: string) {
    this.form.get('adress')?.markAsTouched();
    this.form.get('postalcode')?.markAsTouched();
    if (wordKey) {
      this.establishmentService
        .getAddress(wordKey, 'france')
        .subscribe((value) => {
          this.addressList = value.filter(
            (value: any) => value.address.country_code === 'fr'
          );
        });
    } else {
      this.form.get('adress')?.patchValue('');
      this.form.get('postalcode')?.patchValue('');
      this.form.get('regionName')?.patchValue('');
      this.form.get('regionCode')?.patchValue('');
      this.form.markAsTouched();
    }
  }
  addressSelected(item: any): void {
    const address = item?.address || {};
    this.form.get('lat')?.patchValue(item.lat);
    this.form.get('lon')?.patchValue(item.lon);
    this.form.get('adress')?.patchValue(this.getAdresseFormated(item));
    this.form.get('postalcode')?.patchValue(address.postcode);
    this.form.get('pays')?.patchValue(address.country);
    this.form.get('ville')?.patchValue(address.city);
    // Département = county (e.g. "Ain"), not the city (e.g. "Bourg-en-Bresse").
    this.form.get('departmentName')?.patchValue(address.county || address.city);
    if (!address.postcode) {
      return;
    }
    this.establishmentService
      .getRegionByPostalCode(address.postcode)
      .subscribe({
        next: (res) => {
          const code = res?.[0]?.codeRegion;
          if (!code) {
            return;
          }
          this.form.get('regionCode')?.patchValue(code);
          this.establishmentService
            .getRegionByCode(code)
            .subscribe({
              next: (region) => {
                this.form.get('regionName')?.patchValue(region?.nom || '');
              },
              error: () => {},
            });
        },
        error: () => {},
      });
  }
}
